export type Movie = {
  title: string;
  coachName: string;
  imageUrl: string;
  vimeoId: string;
  length: string;
};

export type Coach = {
  coachName: string;
  description: string;
  coachImageUrl: string;
};

export type Course = {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  coach: Coach;
  movies: Movie[];
};

export const getCourses = (): Course[] => [
  {
    id: 'makikomi-serve',
    title: 'クラブを日本一に導いた「巻き込みサーブ」',
    description:
      '使いこなせば間違いなく優位に立てる！ フェニックス卓球クラブの指導者として2015年全国ホープス女子団体優勝 2016年全日本クラブ卓球選手権大会 男子・女子小中学生の部優勝の経歴を持つ平塚陽一郎コーチ。 これまで数多くのタイトルを獲得したフェニクス卓球クラブが誇る必殺の"巻き込みサーブ"を分かりやすく解説!! 初級者から上級者まで幅広いレベルで通用しますのでぜひマスターしてみましょう！',
    imageUrl:
      'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2021/09/04/large_8611d77b-7a2f-460b-9902-55497f2a7959.png',
    coach: {
      coachName: '平塚陽一郎',
      description:
        'フェニックス卓球クラブの専属コーチ。鬼サーブシリーズは必見。 指導者として2015年全国ホープス女子団体優勝 2016年全日本クラブ卓球選手権大会 男子・女子小中学生の部優勝の経歴を持つ。',
      coachImageUrl:
        'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/thumb_fd921f26-96f3-4725-905b-860edd277cda.png',
    },
    movies: [
      {
        title: 'はじめに【フェニックス秘伝サーブ】',
        vimeoId: '156358587',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/3eec8e65-5dab-4c31-b424-91381b9d5852.png',
        length: '1分12秒',
      },
      {
        title: '横回転サーブ【フェニックス秘伝サーブ】',
        vimeoId: '156358651',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/07a3af48-2d8b-422b-b659-2ecf6844b050.png',
        length: '1分41秒',
      },
      {
        title: 'アップダウンモーション【フェニックス秘伝サーブ】',
        vimeoId: '156358718',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/7398ee43-215c-42b6-9463-2722730079e2.png',
        length: '2分1秒',
      },
      {
        title: 'サーブが効かない時のごまかし方【フェニックス秘伝サーブ】',
        vimeoId: '156358790',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/7a5379d0-c845-4afd-b744-465884190a29.png',
        length: '1分13秒',
      },
      {
        title: '回転のかけ方とポイント【フェニックス秘伝サーブ2】',
        vimeoId: '170908386',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/477338ce-51de-42cf-97fd-56e323255f73.png',
        length: '1分29秒',
      },
      {
        title: 'ラケットを横に使う横上回転【フェニックス秘伝サーブ2】',
        vimeoId: '170908407',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/745570b7-03e3-4452-8d1b-69ca831cc428.png',
        length: '1分36秒',
      },
      {
        title: 'アップダウンモーションを早くするコツ【フェニックス秘伝サーブ】',
        vimeoId: '156358741',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/6ff113d0-e588-4d90-9179-b456a369d22d.png',
        length: '1分3秒',
      },
      {
        title:
          'フェニックス平塚陽一郎が及川瑞基にサーブを伝授! 新シリーズ「及川平塚サーブ」スタート!',
        vimeoId: '183584195',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/7746a278-ed97-4c84-ab68-02df2b0cf0ca.png',
        length: '0分42秒',
      },
      {
        title: '体の回転運動とモーション【フェニックス秘伝サーブ2】',
        vimeoId: '170908393',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/1bcc6f27-5567-4b04-bf68-bf60f9345cc2.png',
        length: '1分13秒',
      },
      {
        title: 'フェイクモーション入りの上回転サーブ【フェニックス秘伝サーブ】',
        vimeoId: '156358768',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/20ee71ea-67fb-4013-a4b9-20e2213fc48f.png',
        length: '0分56秒',
      },
      {
        title: '【及川平塚サーブ】１つのモーションで回転量大幅アップ',
        vimeoId: '183584219',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/5cec9a0e-1b06-4ec9-b516-39b93f50e25a.png',
        length: '3分10秒',
      },
      {
        title: '1つのモーションで複数の回転を【フェニックス秘伝サーブ2】',
        vimeoId: '171349417',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/8908119a-d0a3-4723-87e8-3b3ef9927862.png',
        length: '1分17秒',
      },
      {
        title: 'ジャイロ回転サーブ【フェニックス秘伝サーブ】',
        vimeoId: '156358635',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/6ffa9327-d454-4078-9e0f-aee7eb2706c3.png',
        length: '1分39秒',
      },
      {
        title: '斜め上回転サーブ【フェニックス秘伝サーブ】',
        vimeoId: '156358673',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/63fd41e0-5ae9-468a-8936-1f39bb7e7648.png',
        length: '1分52秒',
      },
      {
        title: 'フェイク付き上下回転サーブの使い分け【フェニックス秘伝サーブ】',
        vimeoId: '156358784',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/8acee99a-2d8f-4d6c-9124-957c73ef7af6.png',
        length: '0分56秒',
      },
      {
        title: '巻き込みサーブのおさらい【フェニックス秘伝サーブ2】',
        vimeoId: '171349441',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/d8092aa1-cead-4a2b-99bb-c5ca80350938.png',
        length: '1分08秒',
      },
      {
        title:
          '平塚コーチ新作のアップダウンモーション【フェニックス秘伝サーブ2】',
        vimeoId: '171349462',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/a5eb462b-020e-482c-879e-19c81daa7516.png',
        length: '1分39秒',
      },
      {
        title: '新作アップダウンモーションの練習法【フェニックス秘伝サーブ2】',
        vimeoId: '171388859',
        coachName: '平塚陽一郎',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/11/177a2ad0-ac66-4a71-96fb-f935992035d7.png',
        length: '2分28秒',
      },
    ],
  },
  {
    id: 'hiraoka-correct-drive',
    title: '平岡義博の正しいドライブ回転のかけ方',
    description:
      '「ドライブをするにはボールを転がす」または「ラケットを転がす距離を長くする」と習っていませんか？\r\n実際は引っ掛ける感覚が、回転をかける原理です。詳しくは動画から！',
    imageUrl:
      'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2021/09/30/b0907fb5-05f7-4e22-8fd0-8c9a4de862f1.png',
    coach: {
      coachName: '平岡義博',
      description:
        '卓球の名門、元明治大学卓球部監督。強豪チームや協会、連盟の技術アドバイザーを行い、多数（宇田、吉村）のトップ選手を指導。分かりやすい卓球指導法を生み出し、多くの指導者からも尊敬される。',
      coachImageUrl:
        'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2018/04/05/thumb_09b7e255-93cc-4c12-b69f-670b47050cf0.png',
    },
    movies: [
      {
        title: 'ドライブをかけるにはラバーの上を長い時間転がす？',
        vimeoId: '272963839',
        coachName: '平岡義博',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2018/06/01/508b2fb8-1648-41bf-a3f6-fbe056eab398.png',
        length: '2分57秒',
      },
      {
        title: 'ドライブはラケットの下の方に当て引っ掛けて回転を掛ける',
        vimeoId: '272966238',
        coachName: '平岡義博',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2018/06/02/a0e9d8f6-aa72-48d4-aa7a-67e92530b4a5.png',
        length: '1分56秒',
      },
      {
        title: 'フリックで引っ掛ける感覚を身につける',
        vimeoId: '241710154',
        coachName: '平岡義博',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2017/11/08/46c6ea09-ca93-4dc1-a79f-432fad40e4c8.jpg',
        length: '3分17秒',
      },
      {
        title: 'フォアドライブ。体の前で早く打つメリットをCC理論で解説。',
        vimeoId: '262561683',
        coachName: '平岡義博',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2018/03/31/3798f06e-0e14-4e30-b21a-12db9b02b6bc.png',
        length: '2分33秒',
      },
      {
        title: 'フォアドライブで困った時の確認法！強く打ってダメなら…',
        vimeoId: '248671620',
        coachName: '平岡義博',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2017/12/25/e74b7deb-cdc5-42a6-9cfb-92e50868fabd.png',
        length: '2分51秒',
      },
      {
        title: '８の字打法のコツ',
        vimeoId: '277866151',
        coachName: '平岡義博',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2018/07/01/8a296e46-a78d-440d-ad74-83f07511188a.png',
        length: '2分30秒',
      },
      {
        title: '【SS理論】バックでの回転をかける感覚を覚える',
        vimeoId: '197023959',
        coachName: '平岡義博',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/12/06/83238a30-56f6-4e7f-86c7-e5d0701f5a42.jpg',
        length: '3分19秒',
      },
    ],
  },
  {
    id: 'itagaki-overcome-receive',
    title: '板垣孝司の全レシーブ克服',
    description:
      '元青森山田学園卓球部監督、現ドイツプロリーグ1部チームのヘッドコーチ。初心者からトップ選手、ジュニア選手に有効な練習方法まで色々なテクニックを紹介します。',
    imageUrl:
      'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2021/09/25/3a359181-9316-4a52-a3a0-39e7268b1b2e.png',
    coach: {
      coachName: '板垣孝司',
      description:
        'フェニックス卓球クラブの専属コーチ。鬼サーブシリーズは必見。 指導者として2015年全国ホープス女子団体優勝 2016年全日本クラブ卓球選手権大会 男子・女子小中学生の部優勝の経歴を持つ。',
      coachImageUrl:
        'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2016/11/17/thumb_c681938b-a147-4dbd-a0ed-f2f758c671db.png',
    },
    movies: [
      {
        title: '右横回転ロングサーブに対するレシーブ',
        vimeoId: '254450405',
        coachName: '板垣孝司',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2018/02/06/4c9bae1d-1adf-4834-9625-033b4bb1973c.jpg',
        length: '1分50秒',
      },
      {
        title: 'バック深くへのバックサーブに対するレシーブ',
        vimeoId: '231191611',
        coachName: '板垣孝司',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2017/08/26/acc117bb-2ceb-424f-a41c-19fe455c1437.jpg',
        length: '4分19秒',
      },
      {
        title: 'サイドに来るサーブに対するレシーブ',
        vimeoId: '232942137',
        coachName: '板垣孝司',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2017/09/08/44a77dc0-d1d8-4413-abd6-127a674e58db.jpg',
        length: '2分42秒',
      },
      {
        title: 'カットマンのフォア前レシーブ',
        vimeoId: '235051629',
        coachName: '板垣孝司',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2017/09/23/38c26ef7-15a8-4ae8-b1e3-c1b194999105.jpg',
        length: '3分09秒',
      },
      {
        title: '低学年の選手がしゃがみ込みサーブに対応する',
        vimeoId: '252664792',
        coachName: '板垣孝司',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2018/01/25/a44c3def-78da-484f-91bc-66c7b30d2620.jpg',
        length: '4分03秒',
      },
      {
        title: '実戦で使えるフォア前レシーブの球質と打法',
        vimeoId: '315626028',
        coachName: '板垣孝司',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2019/02/06/2b626a08-5b89-42c3-b38b-dbeeb02fbb96.jpg',
        length: '4分07秒',
      },
      {
        title: 'ストップのボールの質を上げる',
        vimeoId: '318186438',
        coachName: '板垣孝司',
        imageUrl:
          'https://d1c6amfnfvonwl.cloudfront.net/uploads/images/2019/02/20/5cbae35d-f023-40bc-ae49-ee851790d290.jpg',
        length: '4分08秒',
      },
    ],
  },
];
